import { SupportedVendors } from '../../constants/index.js';
import { coerceToNonEmpty, isUniformArray } from '../../typeguards/index.js';
import { CommerceApiRequestStatuses, SupportedEmbeds, SupportedLinkWrappers, SupportedProductIdentifiers, } from '../constants.js';
export function isCommerceTag(subject) {
    const tag = coerceToNonEmpty(subject);
    if (tag === false) {
        return false;
    }
    if (!('tagName' in tag && typeof tag.tagName === 'string')) {
        return false;
    }
    if (('itemUrl' in tag && typeof tag.itemUrl !== 'string') ||
        ('itemId' in tag && typeof tag.itemId !== 'string') ||
        ('createdAt' in tag && typeof tag.createdAt !== 'string') ||
        ('updatedAt' in tag && typeof tag.updatedAt !== 'string')) {
        return false;
    }
    return true;
}
export function isCommerceItem(subject) {
    const item = coerceToNonEmpty(subject);
    if (item === false) {
        return false;
    }
    if ('shareImage' in item && item.shareImage !== undefined && !isCommerceItemImage(item.shareImage)) {
        return false;
    }
    if ('platformImages' in item &&
        item.platformImages !== undefined &&
        !isUniformArray(item.platformImages, isCommerceItemPlatformImage)) {
        return false;
    }
    if ('classifications' in item &&
        item.classifications !== undefined &&
        !isUniformArray(item.classifications, 'string')) {
        return false;
    }
    if ('requestStatus' in item &&
        item.requestStatus !== undefined &&
        !isCommerceRequestStatus(item.requestStatus)) {
        return false;
    }
    return ('title' in item &&
        typeof item.title === 'string' &&
        'offers' in item &&
        isUniformArray(item.offers, isCommerceOffer) &&
        'identifiers' in item &&
        isCommerceItemIdentifierSet(item.identifiers) &&
        'images' in item &&
        isUniformArray(item.images, isCommerceItemImage));
}
/**
 * Is this a commerce item that meets the needs of a render?  (title/offer)
 */
export function isCompleteCommerceItem(subject) {
    const item = coerceToNonEmpty(subject);
    if (item === false && !isCommerceItem(item)) {
        return false;
    }
    // minimum set of properties needed to render a result
    return item.title !== '' && item.offers?.length > 0;
}
export function isSupportedVendor(subject) {
    return typeof subject === 'string' && SupportedVendors.includes(subject);
}
export function isCommerceEmbedType(subject) {
    return typeof subject === 'string' && SupportedEmbeds.includes(subject);
}
export function isSupportedCommerceItemIdentifier(subject) {
    return (typeof subject === 'string' &&
        SupportedProductIdentifiers.includes(subject));
}
export function isCommerceItemIdentifierSet(subject) {
    const set = coerceToNonEmpty(subject);
    // we need at least one set
    if (set === false) {
        return false;
    }
    if (Object.keys(set).some((key) => SupportedProductIdentifiers.includes(key))) {
        return true;
    }
    return true;
}
export function isCommerceOffer(subject) {
    const offer = coerceToNonEmpty(subject);
    if (offer === false) {
        return false;
    }
    return (offer.url !== undefined &&
        offer.vendor !== undefined &&
        isSupportedVendor(offer.vendor) &&
        (!('identifier' in offer) || offer.identifier !== undefined) &&
        offer.price !== undefined &&
        offer.saved !== undefined &&
        offer.pullDate !== undefined);
}
export function isCommerceItemImage(subject) {
    const image = coerceToNonEmpty(subject);
    if (image === false) {
        return false;
    }
    if (!('isWebP' in image) || !Array.isArray(image.sizes)) {
        return false;
    }
    return image.sizes.filter(isCommerceItemImageSize).length > 0;
}
export function isCommerceItemImageSize(subject) {
    const imageSize = coerceToNonEmpty(subject);
    if (imageSize === false) {
        return false;
    }
    return (imageSize.height !== undefined &&
        imageSize.width !== undefined &&
        imageSize.src !== undefined &&
        imageSize.src.includes('http'));
}
export function isCommerceItemPlatformImage(subject) {
    const image = coerceToNonEmpty(subject);
    if (image === false || image.platform === undefined || image.platformId === undefined) {
        return false;
    }
    if (image.platform === 'tempest') {
        return typeof image.platformId === 'string' && /^ci[a-z0-9]{16}$/.test(image.platformId);
    }
    return false;
}
export function isCommerceRequestStatus(subject) {
    return (typeof subject === 'string' && CommerceApiRequestStatuses.includes(subject));
}
export function isCommerceLinkWrapVendor(subject) {
    return typeof subject === 'string' && SupportedLinkWrappers.includes(subject);
}
export function isCommerceLinkWrapperConfig(subject) {
    return isTrackonomicsLinkWrapperConfig(subject) || isSkimlinksWrapperConfig(subject);
}
export function isSkimlinksWrapperConfig(subject) {
    const def = coerceToNonEmpty(subject);
    return (def !== false &&
        def.vendor === 'Skimlinks' &&
        (def.params === undefined ||
            (typeof def.params?.publisherId === 'string' && def.params.publisherId !== '')));
}
export function isTrackonomicsLinkWrapperConfig(subject) {
    const def = coerceToNonEmpty(subject);
    if (def === false ||
        def.vendor !== 'Trackonomics' ||
        typeof def.options !== 'object' ||
        def.options?.siteCode === undefined ||
        typeof def.options.siteCode !== 'string') {
        return false;
    }
    return isUniformArray(Object.values(def.options), 'string');
}
//# sourceMappingURL=commerceDataTypes.js.map